<template>
  <el-dialog title="添加" :visible.sync="dialogVisible" width="600px" :before-close="handleClose">
    <el-form>
      <el-form-item label="打印内容类型" label-width="140px" required>
        <el-radio v-model="type" label="1">文本</el-radio>
        <el-radio v-model="type" label="2">长文本
          <el-tooltip class="item" effect="dark" content="只显示区域内的文本" placement="top">
            <i class="el-icon-warning"></i>
          </el-tooltip>
        </el-radio>
        <el-radio v-model="type" label="3">条形码</el-radio>
        <el-radio v-model="type" label="4">二维码</el-radio>
        <!-- <el-radio v-model="type" label="4">缩放文本</el-radio> -->
      </el-form-item>
      <!-- <el-form-item label="标题" label-width="140px">
        <el-input maxlength='450' v-model="defaultValue"></el-input>
      </el-form-item> -->
      <el-form-item label="字段名称" label-width="140px">
        <el-select v-model="key">
          <el-option :label="item.label" :value="item.value" v-for="item in printContentList" :key="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <!-- <div style="font-size: 12px; color: red; margin-left: 140px">
        *字段名称和标题同时存在时显示：（标题：字段名称）
      </div> -->
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submit">添 加</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { printContentList } from '@/utils/print'
export default {
  name: "chooseContent",
  data() {
    return {
      dialogVisible: false,
      type: "",
      defaultValue: "",
      key: "",
      printContentList,
      // testData: '测试数据'
    };
  },
  // watch: {
  //   key: function (newVal) {
  //     console.log(newVal,printContentList.filter(item => {
  //       return item.value == newVal
  //     }))
  //     this.testData = printContentList.filter(item => {
  //       return item.value == newVal
  //     }).placeholder
  //   }
  // },
  computed: {
    testData: function () {
      return printContentList.filter(item => {
        return item.value == this.key
      })[0].placeholder
    },
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.type = "";
      this.defaultValue = "";
      this.key = "";
    },
    submit() {
      /**
       * defaultValue 
       * 文本
       * {
          options: {
            width: 80,
            height: 30,
            top: 0,
            left: 0,
            title: "hiprint插件手动添加text", //标题或内容，field 存在：title为标题，打印结果为 title:data , field 不存在：title为内容，打印结果为 title
            // field:'',// 字段名称  html 动态替换字段
            fontSize:'20',//字体大小
            fontWeight:'normal',//字体粗细
            color:'#000',//字体颜色
            lineHeight:20,//字体大小
            textType:'text',//文本类型 text barcode(条形码) qrcode(二维码)
            textAlign: "left",
            hideTitle:false,//隐藏标题
            transform:'0',//旋转角度
          },
          printElementType: {
            //类型 必填
            title: "文本",
            type: "text",
          },
        }
       * 
       * 
       */
      if (!this.type) {
        this.$message.warning("请选择添加类型");
        return;
      }
      let option = {};
      if (this.type == 1) {
        //正常文本
        option = {
          options: {
            width: 80,
            height: 30,
            top: 0,
            left: 0,
            title: this.defaultValue, //标题或内容，field 存在：title为标题，打印结果为 title:data , field 不存在：title为内容，打印结果为 title
            // field:'',// 字段名称  html 动态替换字段
            fontSize: "20", //字体大小
            fontWeight: "lighter ", //字体粗细
            fontFamily: "Microsoft Yahei",
            color: "#000", //字体颜色
            lineHeight: 20, //字体大小
            textType: "text", //文本类型 text barcode(条形码) qrcode(二维码)
            textAlign: "left",
            hideTitle: true, //隐藏标题
            transform: "0", //旋转角度
            testData: this.testData,
          },
          printElementType: {
            //类型 必填
            title: "文本",
            type: "text",
          },
        };
      } else if (this.type == 3) {
        //条形码
        option = {
          options: {
            height: 30,
            width: 105,
            top: 10,
            left: 10,
            title: this.defaultValue, //标题或内容，field 存在：title为标题，打印结果为 title:data , field 不存在：title为内容，打印结果为 title
            // field:'',// 字段名称  html 动态替换字段
            fontSize: "20", //字体大小
            fontWeight: "lighter ", //字体粗细
            fontFamily: "Microsoft Yahei",
            color: "#000", //字体颜色
            lineHeight: 20, //字体大小
            textType: "barcode", //文本类型 text barcode(条形码) qrcode(二维码)
            textAlign: "left",
            hideTitle: true, //隐藏标题
            transform: "0", //旋转角度
            testData: this.testData,
          },
          printElementType: {
            //类型 必填
            title: "文本",
            type: "text",
          },
        };
      } else if (this.type == 4) {
        //二维码
        option = {
          options: {
            height: 30,
            width: 105,
            top: 10,
            left: 10,
            title: this.defaultValue, //标题或内容，field 存在：title为标题，打印结果为 title:data , field 不存在：title为内容，打印结果为 title
            // field:'',// 字段名称  html 动态替换字段
            fontSize: "20", //字体大小
            fontWeight: "lighter ", //字体粗细
            fontFamily: "Microsoft Yahei",
            color: "#000", //字体颜色
            lineHeight: 20, //字体大小
            textType: "qrcode", //文本类型 text barcode(条形码) qrcode(二维码)
            textAlign: "left",
            hideTitle: true, //隐藏标题
            transform: "0", //旋转角度
            testData: this.testData,
          },
          printElementType: {
            //类型 必填
            title: '文本',
            type: "text",
          },
        };
      }  else if (this.type == 2) {
        //长文
        option = {
          options: {
            width: 80,
            height: 30,
            top: 0,
            left: 0,
            title: this.defaultValue, //标题或内容，field 存在：title为标题，打印结果为 title:data , field 不存在：title为内容，打印结果为 title
            // field:'',// 字段名称  html 动态替换字段
            fontSize: "20", //字体大小
            fontWeight: "lighter ", //字体粗细
            fontFamily: "Microsoft Yahei",
            color: "#000", //字体颜色
            lineHeight: 20, //字体大小
            textType: "text", //文本类型 text barcode(条形码) qrcode(二维码)
            textAlign: "left",
            hideTitle: true, //隐藏标题
            transform: "0", //旋转角度
            testData: this.testData,
            styler: function () {
              return {
                overflow: "hidden",
              };
            },
          },
          printElementType: {
            //类型 必填
            title: "长文",
            type: "text",
          },
        };
      } else if (this.type = 4) {
        //测试用缩放文本
        option = {
          options: {
            width: 80,
            height: 30,
            top: 0,
            left: 0,
            title: this.defaultValue, //标题或内容，field 存在：title为标题，打印结果为 title:data , field 不存在：title为内容，打印结果为 title
            // field:'',// 字段名称  html 动态替换字段
            fontSize: "20", //字体大小
            fontWeight: "lighter ", //字体粗细
            fontFamily: "Microsoft Yahei",
            color: "#000", //字体颜色
            lineHeight: 20, //字体大小
            textType: "text", //文本类型 text barcode(条形码) qrcode(二维码)
            textAlign: "left",
            hideTitle: true, //隐藏标题
            transform: "0", //旋转角度
            testData: this.testData,
            styler: function () {
              return {
                transform: "scale(0.5,0.5)"
              };
            },
          },
          printElementType: {
            //类型 必填
            title: "文本",
            type: "text",
          },
        };
      }
      this.key && (option.options.field = this.key);
      !this.defaultValue && delete option.options.title;
      this.$emit("submit", option);
      this.handleClose();
    },
  },
};
</script>
